module.exports = __webpack_public_path__ + "images/feature/weekly-report-1-7912100091de68697d9ed8cba8a9b8a7.png";